export const validateForm = (formValues) => {
  let status = true;
  for (const [k, v] of Object.entries(formValues)) {
    if (v.error == true) {
      status = false;
      break;
    }
  }
  return status;
}
export const getBase64 = async (file) => {
  if (!file) return
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      const base64 = reader.result.toString().replace(/^data:(.*,)?/, "");
      resolve(base64)
    }
    reader.onerror = reject
  })
}

export const validateEmail = (email) => {
  var re = /\S+@\S+\.\S+/;
  return re.test(email);
}

// debounce.js
export const  debounceCustom =(func, delay) =>{
  let timeoutId;
  return function (...args) {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}

  export const convertToLocalTime = (time) => {
    // Create a Date object for the given time in UTC
    const [hours, minutes, seconds] = time.split(':');
    const utcDate = new Date(Date.UTC(1970, 0, 1, hours, minutes, seconds));
    
    // Convert to local time
    const localHours = String(utcDate.getHours()).padStart(2, '0');
    const localMinutes = String(utcDate.getMinutes()).padStart(2, '0');
    const localSeconds = String(utcDate.getSeconds()).padStart(2, '0');
    
    return `${localHours}:${localMinutes}:${localSeconds}`;
  };